import { render } from "./detail-item-section.vue?vue&type=template&id=d7727a3a&ts=true"
import script from "./detail-item-section.vue?vue&type=script&lang=ts"
export * from "./detail-item-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__